// src/pages/Appli/AppliAdmin/clubs-admin/components/ClubsResultsMeta.jsx

import React from "react";

import { pluralize } from "../utils/clubsAdmin.utils";

export default function ClubsResultsMeta({
  totalClubs,
  selectedDepartement,
  debouncedSearch,
  searchTerm,

  loading,
  displayedCount,
  page,
  pageCount,
}) {
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
      <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
        {pluralize(
          totalClubs,
          "club visible",
          "clubs visibles",
        )}
      </span>

      {selectedDepartement ? (
        <span className="rounded-full bg-indigo-50 px-3 py-1 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          Département : {selectedDepartement}
        </span>
      ) : null}

      {debouncedSearch ? (
        <span className="max-w-full truncate rounded-full bg-indigo-50 px-3 py-1 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          Recherche : {searchTerm}
        </span>
      ) : null}

      {!loading && totalClubs > 0 ? (
        <span className="ml-auto text-xs">
          Affichage {displayedCount} • page {page} / {pageCount}
        </span>
      ) : null}
    </div>
  );
}